import '../index.css';
var styles = {
  "content": "bp_tooltip_module_content--05f8e",
  "standard": "bp_tooltip_module_standard--05f8e",
  "error": "bp_tooltip_module_error--05f8e",
  "arrow": "bp_tooltip_module_arrow--05f8e"
};
export { styles as default };